import $ from 'jquery';

$('.menu-item-has-children > a').each(function() {
    const title = $(this).html();
    const theDropdown = $(this).siblings('.dropdown-menu');

    theDropdown.prepend('<li class="mobile-dropdown-back"><img src="/wp-content/themes/balance-activ/img/arrow-green-left.svg">' + title + '</li>');
});